import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { bool, func, node, oneOf, string } from 'prop-types';
import { useListContext } from './list-context';
import { Item } from './list.styles';

const ListAction = _ref => {
  let {
    as,
    children,
    color,
    fill,
    startIcon,
    endIcon,
    onClick
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["as", "children", "color", "fill", "startIcon", "endIcon", "onClick"]);

  const {
    variant,
    divided,
    scale,
    gutters,
    isCollapsed
  } = useListContext();
  return /*#__PURE__*/React.createElement(Item, _extends({
    forwardedAs: as,
    variant: variant,
    startIcon: startIcon,
    endIcon: endIcon,
    gutters: gutters,
    scale: scale,
    color: color,
    fill: fill,
    divided: divided,
    isCollapsed: isCollapsed,
    onClick: onClick,
    "data-testid": "list-action"
  }, props), children);
};

process.env.NODE_ENV !== "production" ? ListAction.propTypes = {
  as: string,
  children: node,
  centered: bool,
  endIcon: node,
  color: string,
  fill: string,
  onClick: func,
  startIcon: node,
  variant: oneOf(['light', 'primary', 'transparent', 'base'])
} : void 0;
ListAction.defaultProps = {
  as: 'div',
  centered: false,
  children: null,
  fontWeight: 'medium',
  gap: 1
};
ListAction.displayName = 'ListAction';
export default ListAction;